import { render, staticRenderFns } from "./ManageSenserSetting.vue?vue&type=template&id=86d2a7d4&"
import script from "./ManageSenserSetting.vue?vue&type=script&lang=js&"
export * from "./ManageSenserSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports